export const CONFIG = {
    variable:{
      PREFIX : "ContactUS"
    },
    urls: {
      apiEndpoint: 'https://contactusapi.agrotikianaptixi.gr',
      Default_API_TOKEN: '',
      getLoginUrl: () => `/`,
      getLogoutUrl: () => `/logout`,
      getResetPasswordUrl: () => `/reset-password`,
      getResetPasswordCompletedUrl: () => `/reset-password-completed`,
      getResetPasswordThankYouUrl: () => `/reset-password-thank-you`,
      
      getDashboardUrl_Admin: () => `/dashboard`,

       getUsersUrl_Admin: () => `/users`,
       getUsersAddUrl_Admin: () => `/user/add`,
       getUsersEditUrl_Admin: (id: string | number ) => `/user/edit/${id}`,
       getUsersViewUrl_Admin: (id: string | number ) => `/user/view/${id}`,

       getOntotitaUrl_Admin: () => `/ontotita`,
       getOntotitaAddUrl_Admin: () => `/ontotita/add`,
       getOntotitaEditUrl_Admin: (id: string | number ) => `/ontotita/edit/${id}`,
       getOntotitaViewUrl_Admin: (id: string | number ) => `/ontotita/view/${id}`,

       getPersonsUrl_Admin: () => `/persons`,
       getPersonsAddUrl_Admin: () => `/person/add`,
       getPersonsEditUrl_Admin: (id: string | number ) => `/persons/edit/${id}`,
       getPersonsViewUrl_Admin: (id: string | number ) => `/persons/view/${id}`,

       getProfileUrl: () => `/profile`,
       getProfileEditUrl: () => `/profile/edit`,
  
       getDynamicOntotitaUrl: (segments: string[]) => {
        return `/${segments.join('/')}`; // Joins the array into a URL string
      },


    },
    
  };